import { LoadingFull } from '@/components/molecules/loading-full'
import { getStaffGuardModalBlocksGlobalLoader, subscribeStaffGuardModalBlocksGlobalLoader } from '@/libs/staff-mutation-guard-store'
import React, { Context, Dispatch, SetStateAction, createContext, useLayoutEffect, useState } from 'react'

type ContextType = {
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
}
const loaderContext = createContext<ContextType | undefined>(undefined)

export const LoaderContextCreator = (): Context<ContextType> => {
  if (!loaderContext) {
    throw new Error('undefined context')
  }
  return loaderContext as Context<ContextType>
}

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [staffModalBlocksLoader, setStaffModalBlocksLoader] = useState(() => getStaffGuardModalBlocksGlobalLoader())

  useLayoutEffect(() => {
    return subscribeStaffGuardModalBlocksGlobalLoader(() => {
      setStaffModalBlocksLoader(getStaffGuardModalBlocksGlobalLoader())
    })
  }, [])

  const showGlobalLoader = isLoading && !staffModalBlocksLoader

  return (
    <loaderContext.Provider value={{ setIsLoading, isLoading }}>
      {children}
      <LoadingFull isLoading={showGlobalLoader} />
    </loaderContext.Provider>
  )
}
